export default __webpack_public_path__ + "static/media/notifbell.14514027.svg";